exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".user-thumb-round[data-v-5fc94782] {\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n}\n", ""]);

